module.exports = __webpack_public_path__ + "media/customizations/carolinaorchards/back-464b82173b60158bc3e1d33ef6c38464.jpg";